import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/open.png';
import _imports_1 from '../assets/images/weixin.png';
import _imports_2 from '../assets/images/weibo.png';
import _imports_3 from '../assets/images/bottomBar/icon_police.png';
const _withScopeId = n => (_pushScopeId("data-v-5bec6872"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bottom-bar"
};
const _hoisted_2 = {
  class: "bottom-desc btoDesc"
};
const _hoisted_3 = {
  class: "desc-dl"
};
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"desc-imgs\" data-v-5bec6872><div class=\"erweima\" data-v-5bec6872><img src=\"" + _imports_0 + "\" alt=\"\" data-v-5bec6872><p data-v-5bec6872>联合智评公众号</p></div><div class=\"erweima\" data-v-5bec6872><img src=\"" + _imports_1 + "\" alt=\"\" data-v-5bec6872><p data-v-5bec6872>联合智评微信</p></div><div class=\"erweima\" data-v-5bec6872><img src=\"" + _imports_2 + "\" alt=\"\" data-v-5bec6872><p data-v-5bec6872>联合智评微博</p></div></div>", 1);
const _hoisted_5 = {
  class: "copyright"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Copyright © 联信智评数字科技有限公司 All rights reserved. ", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010102000650",
  target: "_blank",
  class: "bei1"
}, [/*#__PURE__*/_createElementVNode("span", null, "津ICP备19006954号-8")], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://fisbaobei.ifcert.cn/login#/Home/homeIindex",
  target: "_blank",
  class: "bei1"
}, [/*#__PURE__*/_createElementVNode("span", null, "京金信备（2022）4号")], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "",
  class: "public-law"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}), /*#__PURE__*/_createElementVNode("span", null, "公安备案号：12010102000650")], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "法律及版权声明", -1));
import { onMounted, reactive, ref, watch } from "vue";
export default {
  __name: 'bottomBar',
  setup(__props) {
    const botNav = reactive([{
      name: '产品服务',
      list: [{
        content: '数据服务'
      }, {
        content: '风控服务'
      }, {
        content: '研发与咨询服务'
      }, {
        content: '品牌推广服务'
      }]
    }, {
      name: '公司介绍',
      list: [{
        content: '公司概况'
      }, {
        content: '企业文化'
      }, {
        content: '组织架构'
      }, {
        content: '人才队伍'
      }, {
        content: '社会责任'
      }]
    }, {
      name: '客服服务',
      list: [{
        content: '专业人员'
      }, {
        content: '服务保障'
      }, {
        content: '客服助手'
      }]
    }, {
      name: '联系我们',
      list: [{
        content: '联系地址 : 北京市朝阳区建国门外大街2号PICC大厦12层'
      }, {
        content: '联系电话 : 13436936203'
      }, {
        content: 'E-mail : lxzp@lhcis.com'
      }]
    }]);
    onMounted(() => {
      window.addEventListener('resize', handleResize);
    });
    const handleResize = () => {
      browserWindow.value = window.innerWidth;
    };
    let browserWindow = ref(0);
    watch(browserWindow, (n, o) => {
      let bottomDesc = document.querySelector('.btoDesc');
      if (document.body.clientWidth < 1090) {
        bottomDesc.classList.add('removeBto');
      } else {
        bottomDesc.classList.remove('removeBto');
      }
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(botNav, (item, index) => {
        return _openBlock(), _createElementBlock("dl", {
          key: index,
          class: "dl-ddl"
        }, [_createElementVNode("dt", null, _toDisplayString(item.name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (subItem, subIndex) => {
          return _openBlock(), _createElementBlock("dd", {
            key: subIndex
          }, [_createElementVNode("span", null, _toDisplayString(subItem.content), 1)]);
        }), 128))]);
      }), 128))]), _hoisted_4]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, [_hoisted_6, _hoisted_7, _hoisted_8, _hoisted_9, _createVNode(_component_router_link, {
        to: "/law"
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      })])])]);
    };
  }
};